import { Alert, Button, Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

export interface FailItemProps {
  deferredRequestId: string;
  onFail: (deferredRequestId: string) => void;
  onClose: () => void;
}

const FailItem = ({ deferredRequestId, onFail, onClose }: FailItemProps) => {
  return (
    <ThemedModal onHide={onClose} centered show={true}>
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Fail Deferred Request</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning">
          Are you sure you want to mark this item as failed?
        </Alert>
        If this item hasn't failed, it will be aborted.
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={() => {
            onClose();
            onFail(deferredRequestId);
          }}>
          Fail
        </Button>
        <Button variant="danger" onClick={() => onClose()}>
          Cancel
        </Button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default FailItem;
